/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v1beta1/run.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiRun } from './ApiRun';
import { ApiRunFromJSON, ApiRunFromJSONTyped, ApiRunToJSON, ApiRunToJSONTyped } from './ApiRun';

/**
 *
 * @export
 * @interface ApiListRunsResponse
 */
export interface ApiListRunsResponse {
  /**
   *
   * @type {Array<ApiRun>}
   * @memberof ApiListRunsResponse
   */
  runs?: Array<ApiRun>;
  /**
   * The total number of runs for the given query.
   * @type {number}
   * @memberof ApiListRunsResponse
   */
  total_size?: number;
  /**
   * The token to list the next page of runs.
   * @type {string}
   * @memberof ApiListRunsResponse
   */
  next_page_token?: string;
}

/**
 * Check if a given object implements the ApiListRunsResponse interface.
 */
export function instanceOfApiListRunsResponse(value: object): value is ApiListRunsResponse {
  return true;
}

export function ApiListRunsResponseFromJSON(json: any): ApiListRunsResponse {
  return ApiListRunsResponseFromJSONTyped(json, false);
}

export function ApiListRunsResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ApiListRunsResponse {
  if (json == null) {
    return json;
  }
  return {
    runs: json['runs'] == null ? undefined : (json['runs'] as Array<any>).map(ApiRunFromJSON),
    total_size: json['total_size'] == null ? undefined : json['total_size'],
    next_page_token: json['next_page_token'] == null ? undefined : json['next_page_token'],
  };
}

export function ApiListRunsResponseToJSON(json: any): ApiListRunsResponse {
  return ApiListRunsResponseToJSONTyped(json, false);
}

export function ApiListRunsResponseToJSONTyped(
  value?: ApiListRunsResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    runs: value['runs'] == null ? undefined : (value['runs'] as Array<any>).map(ApiRunToJSON),
    total_size: value['total_size'],
    next_page_token: value['next_page_token'],
  };
}
